module.exports = __webpack_public_path__ + "static/img/bg3.07e112a.png";